import React from "react";

import { useTestUI } from "../../hooks/useTestUI";

const currentVersion = import.meta.env.VITE_APP_VERSION;

function Footer() {
  const { toggleTestUI } = useTestUI();

  return (
    <div
      onClick={toggleTestUI}
      className="w-full self-center rounded-t-lg bg-secondary text-center py-3 mt-20"
    >
      <div className="text-secondary text-xs">
        © {new Date().getFullYear()} Scribenote Inc. All rights
        reserved. v{currentVersion}
        <br />
        <div className="divide-x divide-gray-600">
          <a
            className="text-brand hover:text-indigo-400 cursor-pointer px-2"
            href="https://www.scribenote.com/terms-of-service"
          >
            Terms of Service
          </a>
          <a
            className="text-brand hover:text-indigo-400 cursor-pointer px-2"
            href="https://www.scribenote.com/privacy-policy"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
